<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import backSx from '../common/backSx/index.vue';
	import dowloadSx from '../common/dowloadSx/index.vue';
	export default {
		components: {
			backSx,
			dowloadSx
		},
		data() {
			return {
				isdisabled: true,
				backsxdiag: false,
				sxdiag: false,
				//授信额度
				findLineCredit: {
					updateDate: "2023-8-1 08:02:26",
					periodOfOwnership: "",
					effectiveDateStart: "2023-8-1",
					effectiveDateEnd: "2023-8-31",
					suspensionCreditGrantingLogo: "",
					creditLineThisMonth: "2,000,000,00",
					residualLimit: "2,000,000,00",
					downloadedQuota: "1,000,000,00",
					unusedQuotaHasBeenDownloaded: "5,000,000,00",
				},
				//是否需要更新授信额度
				isSxed: false,
				CxGxDjs: '',
				Fmpeizdata: {}
			};
		},
		mounted() {},
		created() {
			this.initialization();
		},
		methods: {
			//调整授信额度有效期
			AdjustTheValidityPeriodOfTheCreditLine() {
				this.$https.fetchPost('/natural/credit/updateValidityPeriodOfAdjustment?lineOfCredit=' + this
					.findLineCredit.periodOfOwnership).then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.message);
						this.initialization();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//更新授信额度
			GenxingSxed() {
				this.$https.fetchPost('/natural/credit/updateLineCredit').then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.message);
						this.initialization();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//时间撮转时间yyyymmmdd
			timestampToTime(timestamp) {
				var date = new Date(timestamp);
				var Y = date.getFullYear() + '年';
				var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '月';
				var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + '日 ';
				return Y + M + D;
			},
			//时间撮转时间
			timestampToTimesfm(timestamp) {
				var date = new Date(timestamp);
				var Y = date.getFullYear() + '年';
				var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '月';
				var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + '日 ';
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},
			//初始化
			initialization() {
				this.$https.fetchPost('/natural/credit/findLineCredit').then(res => {
					if (res.data.code == '200') {
						this.findLineCredit = res.data.data;
						this.$https.fetchPost('/natural/credit/findCreditConfig').then(res => {
							this.Fmpeizdata = res.data.data;
							this.Fmpeizdata.autoApplyCredit = res.data.data.autoApplyCredit == 1 ? true :
								false;
						});
						if (this.findLineCredit.updateDate == null || this.findLineCredit.updateDate == '') {
							this.isSxed = true;
						} else {
							this.timer();
							setInterval(this.timer, 1000);
						}
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//操作授信管理阈值配置
			isdisabledBaoc() {
				let data = JSON.parse(JSON.stringify(this.Fmpeizdata));
				data.autoApplyCredit = this.Fmpeizdata.autoApplyCredit ? '1' : '0';
				this.$https.fetchPost('/natural/credit/operatorLineCreditThresholdConfig', data).then(res => {
					if (res.data.code == '200') {
						this.isdisabled = true;
						this.initialization();
						this.$message.success('保存成功！');
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//计算倒计时
			timer() {
				var timestamp = new Date().getTime();
				let XiangCha = this.intervalTime(this.findLineCredit.updateDate, timestamp);
				if (XiangCha[1] > 0) {
					this.isSxed = true;
				} else {
					this.isSxed = false;
					let minutes = 60 - XiangCha[2];
					let seconds = 60 - XiangCha[3];
					this.CxGxDjs = minutes == 60 ? '59' : minutes;
					this.CxGxDjs = this.CxGxDjs + ':' + seconds;
				}
			},
			//计算相差时间
			intervalTime(startTime, endTime) {
				// var timestamp=new Date().getTime(); //计算当前时间戳
				var date1 = ''; //开始时间
				date1 = startTime;
				var date2 = endTime; //结束时间
				// var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
				var date3 = date2 - date1; //时间差的毫秒数
				//计算出相差天数
				var days = Math.floor(date3 / (24 * 3600 * 1000));
				//计算出小时数

				var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
				var hours = Math.floor(leave1 / (3600 * 1000));
				//计算相差分钟数
				var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
				var minutes = Math.floor(leave2 / (60 * 1000));

				//计算相差秒数

				var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
				var seconds = Math.round(leave3 / 1000);
				return [days, hours, minutes, seconds];
			},

			//下载
			fordownload() {
				this.sxdiag = true;
			},
			closesxdiag() {
				this.sxdiag = false;
				this.initialization();
			},
			//退回
			forback() {
				this.backsxdiag = true;
			},
			closebacksxdiag() {
				this.backsxdiag = false;
				this.initialization();
			},

			forRouter() {}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>